"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

const constants_1 = require("../constants");

const results_1 = require("../../../results");

const dayjs_1 = __importDefault(require("dayjs"));

const AbstractParserWithWordBoundary_1 = require("../../../common/parsers/AbstractParserWithWordBoundary");

const pattern_1 = require("../../../utils/pattern");

const PATTERN = new RegExp(`(dit|deze|komende|volgend|volgende|afgelopen|vorige)\\s*(${pattern_1.matchAnyPattern(constants_1.TIME_UNIT_DICTIONARY)})(?=\\s*)` + "(?=\\W|$)", "i");
const MODIFIER_WORD_GROUP = 1;
const RELATIVE_WORD_GROUP = 2;

class NLRelativeDateFormatParser extends AbstractParserWithWordBoundary_1.AbstractParserWithWordBoundaryChecking {
  innerPattern() {
    return PATTERN;
  }

  innerExtract(context, match) {
    const modifier = match[MODIFIER_WORD_GROUP].toLowerCase();
    const unitWord = match[RELATIVE_WORD_GROUP].toLowerCase();
    const timeunit = constants_1.TIME_UNIT_DICTIONARY[unitWord];

    if (modifier == "volgend" || modifier == "volgende" || modifier == "komende") {
      const timeUnits = {};
      timeUnits[timeunit] = 1;
      return results_1.ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
    }

    if (modifier == "afgelopen" || modifier == "vorige") {
      const timeUnits = {};
      timeUnits[timeunit] = -1;
      return results_1.ParsingComponents.createRelativeFromReference(context.reference, timeUnits);
    }

    const components = context.createParsingComponents();
    let date = dayjs_1.default(context.reference.instant);

    if (unitWord.match(/week/i)) {
      date = date.add(-date.get("d"), "d");
      components.imply("day", date.date());
      components.imply("month", date.month() + 1);
      components.imply("year", date.year());
    } else if (unitWord.match(/maand/i)) {
      date = date.add(-date.date() + 1, "d");
      components.imply("day", date.date());
      components.assign("year", date.year());
      components.assign("month", date.month() + 1);
    } else if (unitWord.match(/jaar/i)) {
      date = date.add(-date.date() + 1, "d");
      date = date.add(-date.month(), "month");
      components.imply("day", date.date());
      components.imply("month", date.month() + 1);
      components.assign("year", date.year());
    }

    return components;
  }

}

exports.default = NLRelativeDateFormatParser;